import { Component } from '@theme/component';

const KEY = 'eme-sticky-bar-closed';

class EmeStickyClose extends Component {
  connectedCallback() {
    super.connectedCallback();
    if (window.Shopify?.designMode) return;
    const stored = this.#stored();
    if (stored === this.dataset.productId) this.#apply();
    else if (stored) this.#forget();
  }

  close() {
    if (!window.Shopify?.designMode) {
      try {
        sessionStorage.setItem(KEY, this.dataset.productId ?? '');
      } catch {}
    }
    this.#apply();
    const target = this.#focusTarget();
    if (target) target.focus({ preventScroll: true });
    else this.#focusMain();
  }

  #focusMain() {
    const main = document.getElementById('MainContent');
    if (!main) return;
    if (!main.hasAttribute('tabindex')) {
      main.setAttribute('tabindex', '-1');
      const onTab = (event) => {
        if (event.key === 'Tab') release();
      };
      const release = () => {
        main.removeAttribute('tabindex');
        document.removeEventListener('keydown', onTab, true);
        main.removeEventListener('blur', release);
      };
      document.addEventListener('keydown', onTab, true);
      main.addEventListener('blur', release, { once: true });
    }
    main.focus({ preventScroll: true });
  }

  #focusTarget() {
    const section = this.closest('.shopify-section') ?? document;
    const form = section.querySelector(`product-form-component[data-product-id="${this.dataset.productId}"]`);
    const button = form?.querySelector('[ref="addToCartButton"]:not(:disabled)');
    return button instanceof HTMLElement ? button : null;
  }

  #stored() {
    try {
      return sessionStorage.getItem(KEY);
    } catch {
      return null;
    }
  }

  #forget() {
    try {
      sessionStorage.removeItem(KEY);
    } catch {}
  }

  #apply() {
    this.closest('sticky-add-to-cart')?.setAttribute('data-eme-closed', '');
  }
}

if (!customElements.get('eme-sticky-close')) customElements.define('eme-sticky-close', EmeStickyClose);
